/**
 * @file 大字版ua校验
 * @author changyuqing <changyuqing@baidu.com>
 */
import { IS_BIG_BOX } from '@baidu/eop-box/es/os';
/**
 * 判断当前浏览器是否为手百lite
 *
 * @return {boolean} 判断当前浏览器是否为手百lite
 */
export default function is() {
    return IS_BIG_BOX;
}
//# sourceMappingURL=is.js.map